import { useState, useEffect } from 'react';
import './App.css';

export default function App() {
  const [tab, setTab] = useState(0);
  const [search, setSearch] = useState('');
  const [fav, setFav] = useState([]);

  useEffect(() => {
    document.title = '趣玩小盒子 - 精品在线小游戏';
  }, []);

  const allGames = [
    {
      cate: '🔥 热门竞技',
      list: [
        {
          name: '顶级英雄',
          cover: 'https://picsum.photos/id/237/300/180',
          url: 'https://www.topheroes.com/en/landing.html?page_id=26',
          desc: '海外热门放置卡牌，英雄集结策略对战'
        },
        {
          name: '点击英雄',
          cover: 'https://picsum.photos/id/1/300/180',
          url: 'https://www.crazygames.com/game/clicker-heroes',
          desc: '经典放置挂机，升级英雄自动闯关'
        },
        {
          name: '放置打砖块',
          cover: 'https://picsum.photos/id/20/300/180',
          url: 'https://www.crazygames.com/game/idle-breakout',
          desc: '轻松挂机打砖块，解压又好玩'
        },
        {
          name: '英雄战争',
          cover: 'https://picsum.photos/id/2/300/180',
          url: 'https://www.herowars.com/play',
          desc: '回合制英雄对战，组建队伍冒险'
        },
        {
          name: '史诗英雄战争',
          cover: 'https://picsum.photos/id/3/300/180',
          url: 'https://www.epicheroeswar.com/play',
          desc: 'Q版卡通英雄策略，点击即玩'
        }
      ]
    },
    {
      cate: '🧩 休闲解压',
      list: [
        {
          name: '滑雪大冒险3D',
          cover: 'https://picsum.photos/id/15/300/180',
          url: 'https://snowrider3d.games/zh-cn/',
          desc: '3D滑雪竞速，躲避障碍闯关'
        },
        {
          name: '合成大西瓜',
          cover: 'https://picsum.photos/id/40/300/180',
          url: 'https://watermelongame.com/',
          desc: '网红合成玩法，合成超大西瓜'
        },
        {
          name: '打字贪吃蛇',
          cover: 'https://picsum.photos/id/24/300/180',
          url: 'https://zty.pe/',
          desc: '打字消灭敌机，休闲又练手速'
        },
        {
          name: '贪婪贪吃蛇',
          cover: 'https://picsum.photos/id/26/300/180',
          url: 'https://greed.frvr.com/',
          desc: '经典贪吃蛇升级版，收集道具成长'
        },
        {
          name: '2048',
          cover: 'https://picsum.photos/id/30/300/180',
          url: 'https://play2048.co/',
          desc: '经典数字合成，轻松益智'
        },
        {
          name: '像素小鸟',
          cover: 'https://picsum.photos/id/32/300/180',
          url: 'https://flappybird.io/',
          desc: '经典虐心小游戏，控制小鸟飞行'
        },
        {
          name: '贪吃蛇大作战',
          cover: 'https://picsum.photos/id/36/300/180',
          url: 'https://slither.io/',
          desc: '多人在线贪吃蛇，实时对战成长'
        },
        {
          name: '占地大作战',
          cover: 'https://picsum.photos/id/37/300/180',
          url: 'https://paper-io.com/',
          desc: '圈地占领玩法，多人对抗竞技'
        }
      ]
    },
    {
      cate: '🎯 射击动作',
      list: [
        {
          name: '子弹力量',
          cover: 'https://picsum.photos/id/4/300/180',
          url: 'https://bulletforce.online/',
          desc: '3D网页射击，多人在线对战'
        },
        {
          name: '鸡蛋射击',
          cover: 'https://picsum.photos/id/5/300/180',
          url: 'https://shellshock.io/',
          desc: '卡通多人射击，化身鸡蛋对战'
        },
        {
          name: '僵尸大逃杀',
          cover: 'https://picsum.photos/id/6/300/180',
          url: 'https://zombsroyale.io/',
          desc: '2D卡通大逃杀，快速开局竞技'
        }
      ]
    },
    {
      cate: '🧠 益智解谜',
      list: [
        {
          name: '迷你迷宫',
          cover: 'https://picsum.photos/id/10/300/180',
          url: 'https://maze.toys/mazes/mini/',
          desc: '轻松迷宫闯关，锻炼方向感'
        },
        {
          name: '六边形消除',
          cover: 'https://picsum.photos/id/11/300/180',
          url: 'https://hex.frvr.com/',
          desc: '六边形拼图消除，轻松解压'
        },
        {
          name: '五子棋',
          cover: 'https://picsum.photos/id/12/300/180',
          url: 'http://guozhivip.com/fun/wzq/',
          desc: '经典五子棋，人机对战'
        },
        {
          name: '俄罗斯方块',
          cover: 'https://picsum.photos/id/13/300/180',
          url: 'https://tetris.com/play-tetris/',
          desc: '官方正版俄罗斯方块，经典永不过时'
        },
        {
          name: '数独',
          cover: 'https://picsum.photos/id/14/300/180',
          url: 'https://sudoku.com/',
          desc: '数字逻辑益智，多难度可选'
        },
        {
          name: '扫雷',
          cover: 'https://picsum.photos/id/16/300/180',
          url: 'https://minesweeper.online/',
          desc: '电脑经典扫雷，网页复刻版'
        },
        {
          name: '割绳子',
          cover: 'https://picsum.photos/id/17/300/180',
          url: 'https://www.crazygames.com/game/cut-the-rope',
          desc: '经典益智割绳子，帮助小怪兽吃糖'
        }
      ]
    },
    {
      cate: '🎹 趣味创意',
      list: [
        {
          name: '在线钢琴',
          cover: 'https://picsum.photos/id/18/300/180',
          url: 'https://www.autopiano.cn/',
          desc: '网页钢琴，键盘自由弹奏'
        },
        {
          name: '俄罗斯方块怀旧版',
          cover: 'https://picsum.photos/id/19/300/180',
          url: 'http://guozhivip.com/fun/els/',
          desc: '经典俄罗斯方块，童年怀旧版'
        }
      ]
    },
    {
      cate: '🕹️ 经典怀旧',
      list: [
        {
          name: '超级马里奥',
          cover: 'https://picsum.photos/id/7/300/180',
          url: 'https://supermario-game.com/',
          desc: '经典超级玛丽，童年回忆复刻'
        },
        {
          name: '吃豆人',
          cover: 'https://picsum.photos/id/8/300/180',
          url: 'https://pacman.live/',
          desc: '经典吃豆人，躲避怪物闯关'
        }
      ]
    }
  ];

  const hotGames = allGames.flatMap(c => c.list).slice(0, 12);

  const toggleFav = (game) => {
    setFav(prev => prev.some(x => x.name === game.name)
      ? prev.filter(x => x.name !== game.name)
      : [...prev, game]
    );
  };

  const getFilteredGames = () => {
    const source = tab === -1 ? fav : allGames[tab]?.list || [];
    return source.filter(game =>
      game.name.toLowerCase().includes(search.toLowerCase())
    );
  };

  const filteredGames = getFilteredGames();

  return (
    <div className="app">
      <header className="header">
        <div className="logo">🎮 趣玩小盒子</div>
        <h1>趣玩小盒子 · 精品在线小游戏</h1>
        <p>免下载 · 免安装 · 点开即玩 · 绿色安全</p>
      </header>

      <div className="search-bar">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="🔍 输入游戏名称搜索..."
          className="search-input"
        />
      </div>

      <div className="tabs">
        {allGames.map((category, index) => (
          <button
            key={index}
            className={`tab ${tab === index ? 'tab-active' : ''}`}
            onClick={() => setTab(index)}
          >
            {category.cate}
          </button>
        ))}
      </div>

      <div className="section-title">
        <span>🔥 全网热门排行</span>
        {fav.length > 0 && (
          <button className="fav-btn" onClick={() => setTab(-1)}>
            ⭐ 我的收藏({fav.length})
          </button>
        )}
      </div>

      <div className="hot-scroll">
        {hotGames.map((game, index) => (
          <a key={index} href={game.url} target="_blank" rel="noreferrer" className="hot-card">
            <img src={game.cover} alt={game.name} loading="lazy" className="hot-cover" />
            <div className="hot-name">{game.name}</div>
          </a>
        ))}
      </div>

      <div className="section-title">
        {tab === -1 ? '⭐ 我的收藏' : allGames[tab]?.cate || '暂无游戏'}
      </div>

      <main className="game-grid">
        {filteredGames.length > 0 ? (
          filteredGames.map((game, index) => (
            <div key={index} className="game-card">
              <img
                src={game.cover}
                className="game-cover"
                alt={game.name}
                loading="lazy"
              />
              <div className="game-info">
                <h3 className="game-name">{game.name}</h3>
                <p className="game-desc">{game.desc}</p>
              </div>
              <div className="game-btns">
                <button
                  className="star-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFav(game);
                  }}
                >
                  {fav.some(x => x.name === game.name) ? '⭐' : '☆'}
                </button>
                <a href={game.url} target="_blank" rel="noreferrer" className="play-btn">
                  开始游戏
                </a>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">🎮 暂无相关游戏</div>
        )}
      </main>

      <footer className="footer">
        <p>© 2026 趣玩小盒子 - 精品在线小游戏聚合平台</p>
        <p>所有游戏均来源于网络，仅用于展示交流</p>
        <p>联系邮箱：ltianw@qq.com</p>
      </footer>
    </div>
  );
}